import { CALL_API } from '../middleware/api';
import randString from '../utils/codegenerator';

export const changeRoute = route => ({
  type: 'CHANGE_ROUTE',
  route
});

export const saveLikeID = (likeid, likeurl) => ({
  type: 'SAVE_LIKE_ID',
  likeid,
  likeurl
});

export const saveError = errorCode => ({
  type: 'ERROR',
  errorCode
});

export const resign = () => (
  window.close()
);


export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

// Relies on the custom API middleware defined in ../middleware/api.js.
const loginUserCall = (loginuser, surname, prememberMe) => {
  const rememberMe = prememberMe ? '1' : '0';
  const code = randString(40);
  return {
    [CALL_API]: {
      types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE],
      endpoint: `/api/shp/v2/like-pots/devices/register`, // `/WebApi/tinaba/tinabaLike/claimCookie`
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: {
        code,
        username: loginuser,
        lastName: surname,
        rememberMe: prememberMe
      }
    },
    loginData: {
      loginuser,
      surname,
      code,
      rememberMe
    }
  };
};

// Verify user based on username and password
// Relies on Redux Thunk middleware.
export const loginUser = (login, surname, rememberMe) => (dispatch) => {
  let finalnumber = login;
  if (login.substring(0, 1) !== '+') {
    finalnumber = `+39${login}`;
  }
  return dispatch(loginUserCall(finalnumber, surname, rememberMe)).then((action) => {
    if (action.type === LOGIN_SUCCESS) {
      (dispatch(changeRoute('Verified')));
    }
  });
};

export const VERIFY_REQUEST = 'VERIFY_REQUEST';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const VERIFY_FAILURE = 'VERIFY_FAILURE';

// Relies on the custom API middleware defined in ../middleware/api.js.
const checkTrustCall = (login, surname, code) => ({
  [CALL_API]: {
    types: [VERIFY_REQUEST, VERIFY_SUCCESS, VERIFY_FAILURE],
    endpoint: `/api/shp/v2/like-pots/devices/retrieve`, // `/WebApi/tinaba/tinabaLike/retrieveCookie`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: {
      code,
      username: login,
      lastName: surname,
    }
  }
});

// Check if the code is confirmed by the user
// Relies on Redux Thunk middleware.
export const checkTrust = () => (dispatch, getState) =>

    dispatch(checkTrustCall(getState().loginStatus.loginuser, getState().loginStatus.surname, getState().loginStatus.code)).then((action) => {
      if (action.type === VERIFY_SUCCESS) {
        (dispatch(changeRoute('Confirm')));
      }
      if (action.type === VERIFY_FAILURE) {
        (dispatch(changeRoute('Verified')));
      }
    });

export const DONATION_REQUEST = 'DONATION_REQUEST';
export const DONATION_SUCCESS = 'DONATION_SUCCESS';
export const DONATION_FAILURE = 'DONATION_FAILURE';

// Do the donation
// Relies on the custom API middleware defined in ../middleware/api.js.
const doDonationCall = (tlid, url) => ({
  [CALL_API]: {
    types: [DONATION_REQUEST, DONATION_SUCCESS, DONATION_FAILURE],
    endpoint: `/api/shp/v2/like-pots/donate/${tlid}`, // `/WebApi/tinaba/tinabaLike/donateLike`,
    method: 'POST',
    headers: {
      authorization: 'Basic d2ViYXBwOndlYmFwcF9zZWNyZXQ=',
      'content-type': 'application/json'
    },
    data: {
      url
    }
  }
});

// Verify user based on username and password
// Relies on Redux Thunk middleware.
export const doDonation = () => (dispatch, getState) => {
  dispatch(doDonationCall(getState().tlid.likeid, getState().tlid.likeurl)).then((action) => {
    if (action.type === DONATION_SUCCESS) {
      (dispatch(changeRoute('DonationSuccess')));
    } else if (action.type === DONATION_FAILURE && !getState().loginStatus.logged) { // TODO: gestione migliore dei casi di errore
      (dispatch(changeRoute('LoginForm')));
    } else if (action.type === DONATION_FAILURE && getState().loginStatus.logged) { // TODO: gestione migliore dei casi di errore
      if (action.error) (dispatch(saveError(action.error)));
      (dispatch(changeRoute('DonationFailure')));
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/